import createCache from 'services/createCache';

export default createCache({
	teamAreasMap: {
		map: null,
		areasLayer: null,
	},
});
